import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Icon from 'components/Icon';
import { PAGE_TYPE_WATCH_FREE } from 'helpers/ContentHelper';
import { isMobileBreakpoint, isTabletBreakpoint } from 'helpers/BreakpointHelper';
import Favorite, { FAVORITE_PLUS_CIRCLE, FAVORITE_TYPE_WATCHLIST } from 'components/Favorite';
import favoriteTheme from 'app/themes/Favorite.css';
import style from './SecondaryButtons.module.scss';

const SecondaryButtons = ({
  breakpoint,
  disableScroll,
  favoritableItems,
  favoritesManager,
  item,
  setPlayerVisibility,
}) => {
  const { retired, id } = item;
  const { autoPlayPreviewParam } = window.ExternalConfig;

  const data = {
    favoritableItems,
    showID: id,
  };

  const previewVideo = _.get(item, 'previewVideo.member.0', null);

  const shouldRenderFavoriteButton = !retired && id !== PAGE_TYPE_WATCH_FREE;

  const shouldRenderPreview = !!previewVideo;

  const shouldRenderShareButton = !!(
    navigator.share &&
    autoPlayPreviewParam &&
    (isMobileBreakpoint(breakpoint) || isTabletBreakpoint(breakpoint))
  );

  const previewClickHandler = () => {
    setPlayerVisibility(true);
    disableScroll({ disableScroll: true, bodyOnly: true });
  };

  const shareClickHandler = () => {
    const separator = window.location.href.indexOf('?') === -1 ? '?' : '&';
    const shareUrl = autoPlayPreviewParam ? window.location.href + separator : window.location.href;
    if (navigator.share) {
      navigator
        .share({
          url: shareUrl,
        })
        .catch(console.error);
    }
  };

  return (
    <div className={style.container}>
      {shouldRenderFavoriteButton ? (
        <div className={style.section}>
          <Favorite
            manager={favoritesManager}
            setFavorites={favoritesManager?.setFavorites}
            data={data}
            theme={favoriteTheme}
            type={FAVORITE_TYPE_WATCHLIST}
            iconType={FAVORITE_PLUS_CIRCLE}
          />
          <div className={style.iconText}>Watchlist</div>
        </div>
      ) : null}
      {shouldRenderPreview ? (
        <div className={style.section} onClick={previewClickHandler}>
          <Icon icon="trailer" color="white" size="medium-large" />
          <div className={style.iconText}>Trailer</div>
        </div>
      ) : null}
      {shouldRenderShareButton ? (
        <div className={style.section} onClick={shareClickHandler}>
          <Icon icon="share" color="white" size="medium-large" />
          <div className={style.iconText}>Share</div>
        </div>
      ) : null}
    </div>
  );
};

SecondaryButtons.propTypes = {
  breakpoint: PropTypes.string,
  disableScroll: PropTypes.func,
  favoritableItems: PropTypes.shape({}),
  favoritesManager: PropTypes.shape({}),
  setPlayerVisibility: PropTypes.func,
  item: PropTypes.shape({
    screenUrl: PropTypes.string,
    name: PropTypes.string,
  }),
  episode: PropTypes.shape({}),
};

export default SecondaryButtons;
